import { render, staticRenderFns } from "./PlayerAvatar.vue?vue&type=template&id=76f60eea&scoped=true&"
import script from "./PlayerAvatar.vue?vue&type=script&lang=js&"
export * from "./PlayerAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAvatar.vue?vue&type=style&index=0&id=76f60eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f60eea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
